import qs from "qs";
import requestSC from "@/utils/requestSC";

export default {
  data() {
    return {
      visible: false,
      searchKey: "",
      searchCarsList: [],
      recentCars: [],
      recentCarsIds: [],
      recentCarsList: [],
    };
  },
  methods: {
    open(recentCarsList, recentCars) {
      console.log("recentCarsList", recentCarsList);
      console.log("recentCars", recentCars);
      this.visible = true;
      this.recentCars = recentCars || [];
      this.recentCarsList = recentCarsList || [];
    },
    close() {
      this.visible = false;
    },
    confirm() {
      console.log("this.recentCars", this.recentCars);
      this.$emit("confirm", this.recentCars);
      this.visible = false;
    },
    recentCarsChange(val) {
      console.log("val", val);
      // this.recentCarsIds = [];
      // if (val && val.length) {
      // } else {
      //   this.recentCarsIds = [];
      // }
      // console.log("val", val);
    },
    async searchSubmit() {
      const { searchKey } = this;

      if (!this.searchKey) {
        return;
      }

      const loading = this.$loading({
        lock: false,
        text: "加载中...",
        background: "rgba(0, 0, 0, 0.7)",
        customClass: "seller-style",
      });
      const { code, msg, data } = await requestSC.post(`mj/order/manage/getHlCarsList`, qs.stringify({ name: searchKey }));
      loading.close();

      if (code == "0") {
        this.searchCarsList = data.map((item) => ({
          ...item,
          goodsWeight: undefined,
          freightMoney: undefined,
        }));
      } else {
        this.$message.error(msg);
      }
    },
  },
};
